export function bem(...classes: (string | false | undefined | null)[]): string {
    if (classes.length < 2) {
        return classes.first() || ""
    }
    return classes
        .filter((c) => c)
        .map((x, idx) => (idx && `${classes.first()}--${x}`) || x)
        .join(" ")
}
